//import minKnightMoves from "./board";
import { appGUI } from "./gui.js";
import "./styles/styles.css";
import "./styles/normalize.css";

document.body.onload = appGUI.createElements();
